import {
  previewPrice as publicPreviewPrice,
  calculatePrice as publicCalculatePrice,
} from './bookings-v2-price-info-pricing.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const previewPrice: MaybeContext<
  BuildRESTFunction<typeof publicPreviewPrice> & typeof publicPreviewPrice
> = /*#__PURE__*/ createRESTModule(publicPreviewPrice);
export const calculatePrice: MaybeContext<
  BuildRESTFunction<typeof publicCalculatePrice> & typeof publicCalculatePrice
> = /*#__PURE__*/ createRESTModule(publicCalculatePrice);

export {
  MultiServiceBookingType,
  ResourceTransparency,
  LocationType,
  SelectionMethod,
  ValueType,
  BookingStatus,
  PaymentStatus,
  SelectedPaymentOption,
  Platform,
  Actor,
  IdentityType,
} from './bookings-v2-price-info-pricing.universal.js';
export {
  PriceInfo,
  PriceInfoTotalPriceOneOf,
  BookingLineItem,
  ServiceChoice,
  ServiceChoiceChoiceOneOf,
  Duration,
  PricingServiceChoices,
  PriceDescriptionInfo,
  PreviewPriceRequest,
  PreviewPriceResponse,
  CalculatePriceRequest,
  Booking,
  BookingParticipantsInfoOneOf,
  BookedEntity,
  BookedEntityItemOneOf,
  BookedSlot,
  BookedResource,
  Location,
  PhoneCall,
  ResourceSelection,
  BookedSchedule,
  ContactDetails,
  Address,
  AddressStreetOneOf,
  StreetAddress,
  AddressLocation,
  Subdivision,
  CustomFormField,
  BookingSource,
  ParticipantNotification,
  IdentificationData,
  IdentificationDataIdOneOf,
  FlowControlSettings,
  ExtendedFields,
  ParticipantChoices,
  ServiceChoices,
  MultiServiceBookingInfo,
  BookedAddOn,
  CalculatePriceResponse,
} from './bookings-v2-price-info-pricing.universal.js';
export {
  MultiServiceBookingTypeWithLiterals,
  ResourceTransparencyWithLiterals,
  LocationTypeWithLiterals,
  SelectionMethodWithLiterals,
  ValueTypeWithLiterals,
  BookingStatusWithLiterals,
  PaymentStatusWithLiterals,
  SelectedPaymentOptionWithLiterals,
  PlatformWithLiterals,
  ActorWithLiterals,
  IdentityTypeWithLiterals,
  PreviewPriceApplicationErrors,
  CalculatePriceApplicationErrors,
} from './bookings-v2-price-info-pricing.universal.js';
